//@flow
import React from "react";

const colorMap = {
  Active: "background-color-mint",
  Inactive: "background-color-berry",
  Open: "background-color-coffee",
  Closed: "background-color-mint",
  Medical: "background-color-ice",
  "Non-Medical": "background-color-berry",
  Overdue: "text-white background-color-risk-high",
  "Due Today": "background-color-berry",
  Todo: "text-white background-color-risk-medium",
  "Not Downloaded": "text-white background-color-negative",
  "Partially Downloaded": "background-color-pumpkin-orange",
  "In Progress": "background-color-ice",
  "Pending Approval": "background-color-rose-d1",
};

export default function statusPill(text: string, onClick?: Function, className?: string) {
  if (!colorMap[text])
    return (
      <div
        className={`gs-badge background-color-secondary text-color-light-grey ${className || ""}`}
      >
        {text}
      </div>
    );
  return (
    <div
      onClick={onClick}
      title={text}
      className={`gs-badge ${className || ""} ${colorMap[text]} ${onClick ? "cursor-pointer" : ""}`}
    >
      {text}
    </div>
  );
}
